/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

export const BLOG_HOME_ROUTE = '/diy';

export const BLOG_POST_ROUTE = '/diy/[...blogPath]';

export const BLOG_REVIEWERS_ROUTE = '/diy/reviewers/[...reviewersPath]';

export const DEFAULT_RELATED_BLOGS_LIMIT = 6;

export const VIDEO_FALLBACK_IMAGE = '/images/video-default-poster-gray.svg';
